import * as Yup from "yup";

export const SignInSchema = Yup.object().shape({
  username: Yup.string().required("sign-in.username-required"),
  password: Yup.string().required("sign-in.password-required"),
});
